module.exports = __webpack_public_path__ + "img/li.3109bec4.svg";